import { services } from '../api'

const state = {
	companyAllData: {}
}

const getters = {

}

const actions = {
	getCompanyById ({commit}, id) {
		return services.company.getCompanyById(id)
			.then((response) => {
				return response.data.data
			})
			.catch((error) => {
				console.error(error)
			})
	},
	getCompanyBySearch ({commit}, company) {
		return services.company.getCompanyBySearch(company)
			.then((response) => {
				return response.data.data
			})
			.catch((error) => {
				console.error(error)
			})
	},
	getCompanyAll ({commit}, params) {
		return services.company.getCompanyAll(params)
			.then((response) => {
				commit('SET_COMPANY_ALL', response.data)
				return response.data.data
			})
			.catch((error) => {
				console.error(error)
			})
	}
}

const mutations = {
	SET_COMPANY_ALL (state, payload) {
		state.companyAllData = payload
	}
}

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions
}



// WEBPACK FOOTER //
// ./src/vuex/modules/company.js